import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';
import {
  CreateApiTokenRequest,
  CreateApiTokenResponse
} from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { getGrpcPromise } from '@monorepo/grpc';

const createApiToken = (): Promise<CreateApiTokenResponse.AsObject | null> => {
  const getApiTokensRequest = new CreateApiTokenRequest();
  return getGrpcPromise(WebAuthService.CreateApiToken)(getApiTokensRequest);
};

export default createApiToken;
